import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { User } from '../../models/user';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private storageKey = 'sdmInvoicerCurrentUser';
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient) {

    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem(this.storageKey)));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  IsLoggedIn(): boolean {
    return this.currentUserSubject.value !== null;
  }

  Login(username: string, password: string): Observable<any> {

    return this.http.post<any>(`${environment.apiUri}api/users/authenticate`, { username, password })
      .pipe(map(user => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem(this.storageKey, JSON.stringify(user));
        this.currentUserSubject.next(user);
        return user;
      }), catchError(this.handleError));
  }

  Logout() {
    // remove user from local storage to log user out
    localStorage.removeItem(this.storageKey);
    this.currentUserSubject.next(null);
  }

  IsUserSupervisor(): boolean {
    let user: User;
    user = JSON.parse(localStorage.getItem(this.storageKey));

    var esSuper = false;
    if (user.supervisor == true) { esSuper = true; }

    return esSuper;
  }

  HasStatsModule(): boolean {
    let user: User;
    user = JSON.parse(localStorage.getItem(this.storageKey));

    var hasStats = false;
    if (user.stats == true) { hasStats = true; }

    return hasStats;
  }

  HasStats2Module(): boolean {
    let user: User;
    user = JSON.parse(localStorage.getItem(this.storageKey));

    var hasStats = false;
    if (user.stats2 == true) { hasStats = true; }

    return hasStats;
  }

  HasTemplatesModule(): boolean {
    let user: User;
    user = JSON.parse(localStorage.getItem(this.storageKey));

    var hasTemplates = false;
    if (user.plantilla == true) { hasTemplates = true; }

    return hasTemplates;
  }

  HasClientModule(): boolean {

    let user: User;
    user = JSON.parse(localStorage.getItem(this.storageKey));

    var hasClient = false;
    if (user.facturasCliente != null && user.facturasCliente != "" && user.facturasCliente != " ") { hasClient = true; }

    return hasClient;
  }

  HasIgnorarClienteModule(): boolean{

    let user: User;
    user = JSON.parse(localStorage.getItem(this.storageKey));

    var hasClient = false;
    if (user.ignorarCliente != null && user.ignorarCliente != "" && user.ignorarCliente != " ") { hasClient = true; }

    return hasClient;
  }

  private handleError(err: HttpErrorResponse) {

    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      switch (err.status) {
        case 400:
        case 401:
        case 402:
        case 403:
        case 404:
        case 405:
          errorMessage = 'Datos de acceso incorrectos.';
          break;
        case 500:
        case 501:
        case 502:
        case 503:
        case 504:
        case 505:
          errorMessage = 'Ocurrió un error al identificar al usuario.';
          break;
        default:
          errorMessage = `Error: ${err.status}, mensaje: ${err.message}`;
          break;
      }
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

  QuitarDocumentosAsignados(usuario: string): Observable<boolean> {
    console.log("USER:" + usuario);
    const usuarioBTOA = btoa(usuario);

    return this.http.get<boolean>(`${environment.apiUri}api/users/QuitarDocumentosAsignados/${usuarioBTOA}`);
  }

  ObtenerEstadoMantenimiento(): Observable<boolean> {

    return this.http.get<boolean>(`${environment.apiUri}api/configuracion/getMantenimiento`);
  }
}
